import React from "react";

export const Avatar = ({ nome, foto, size = 36, ring = "" }) => {
  const ini = (nome || "?").split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
  if (foto) return <img src={foto} alt={nome} className={`rounded-full object-cover ${ring}`} style={{ width: size, height: size }} />;
  return <div className={`rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-semibold shrink-0 ${ring}`} style={{ width: size, height: size, fontSize: size * 0.36 }}>{ini}</div>;
};

export default Avatar;
